/*
 * サブシステム名：XXXX
 * 機能名：運行実績登録
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import dayjs from 'dayjs'
// import complements from '@/rahmen/complement'

import header from '@/ddv2.library/header'
// import indexeddb from '@/ddv2.library/indexeddb'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdQuillEditor from '@/components/DdQuillEditor'

export default {
  name: 'prmClockingInOut',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdIconButtonWithTooltip,
    DdQuillEditor
  },
  data: () => ({
    viewTitles: '出退勤管理',
    currentDate: null,
    currentWeedDay: null,
    currentTime: null,

    editorOption: {
      theme: 'bubble',
      placeholder: '',
      modules: {
        toolbar: []
      }
    },

    kanaList: [
      { value: 1, text: 'ア' },
      { value: 2, text: 'カ' },
      { value: 3, text: 'サ' },
      { value: 4, text: 'タ' },
      { value: 5, text: 'ナ' },
      { value: 6, text: 'ハ' },
      { value: 7, text: 'マ' },
      { value: 8, text: 'ヤ' },
      { value: 9, text: 'ラ' },
      { value: 10, text: 'ワ' },
      { value: 11, text: 'Ａ' }
    ],
    selectedKanaValue: 1, // デフォルト選択
    selectedPerson: null,
    notificationMessage: '<p><strong style="color: rgb(230, 0, 0);" class="ql-size-large">安全運転を心がけましょう</strong></p>',
    greetingIcon: null,
    actionMessage: null,
    clearTimer: null,

    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      currentKaishaCode: 'users/currentKaishaCode',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((a, b) => {
        const nameA = a.jininNmKanaSei || ''
        const nameB = b.jininNmKanaSei || ''
        return nameA.localeCompare(nameB, 'ja')
      })
    },
    filteredPerson () {
      const kanaMap = {
        1: ['ア', 'イ', 'ウ', 'エ', 'オ'],
        2: ['カ', 'キ', 'ク', 'ケ', 'コ'],
        3: ['サ', 'シ', 'ス', 'セ', 'ソ'],
        4: ['タ', 'チ', 'ツ', 'テ', 'ト'],
        5: ['ナ', 'ニ', 'ヌ', 'ネ', 'ノ'],
        6: ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ'],
        7: ['マ', 'ミ', 'ム', 'メ', 'モ'],
        8: ['ヤ', 'ユ', 'ヨ'],
        9: ['ラ', 'リ', 'ル', 'レ', 'ロ'],
        10: ['ワ', 'ヲ', 'ン']
      }

      // すべての五十音をフラットにして重複なしでセットに
      const knownKana = new Set([].concat(...Object.values(kanaMap)))

      return this.filteredJininList.filter(elem => {
        const firstKana = elem.jininNmKanaSei?.charAt(0)
        if (!firstKana) return false

        if (this.value === 11) {
          // knownKana に含まれていなければ「それ以外」とみなす
          return !knownKana.has(firstKana)
        } else {
          const kanaGroup = kanaMap[this.selectedKanaValue] || []
          return kanaGroup.includes(firstKana)
        }
      })
    },
    inputPersonNm () {
      if (this.selectedPerson === null) return '選択してください'
      const x = this.filteredJininList.findIndex(elem => elem.id === this.selectedPerson)
      return this.filteredJininList[x].jininNmSei
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
    const self = this
    this.timer = setInterval(() => {
      const wDate = date.getCurrentDate()
      const tDate = wDate.split('/')
      self.currentDate = tDate[0] + '年' + tDate[1] + '月' + tDate[2] + '日'
      self.currentWeedDay = self.setDayOfWeek(wDate)
      self.currentTime = date.getCurrentTime()
    }, 1000) // 1秒ごとに更新
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    fetchData: function () {
    },
    initialize () {
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            self.rec = { ...self.rec, ...c }
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        // requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    initBindVariables: function () {
      const wDate = date.getCurrentDate()
      const tDate = wDate.split('/')
      this.currentDate = tDate[0] + '年' + tDate[1] + '月' + tDate[2] + '日'
      this.currentWeedDay = this.setDayOfWeek(wDate)
      this.currentTime = date.getCurrentTime()
    },

    onReturnButtonClick: function (e) {
    },
    onCancelButtonClick: function (e) {
    },
    onDeleteButtonClick: function (e) {
    },
    onCopyButtonClick: function (e) {
    },
    onSaveButtonClick: function (e) {
      console.log('save', this)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.id !== this.rec.id
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            console.log('★transition')
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      return false
    },
    registerValidate: function () {
      return true
    },
    deleteValidate: function () {
      return true
    },

    onClickClockIn: function () {
      this.actionMessage = 'おはようございます！'
      this.greetingIcon = 1
      this.clearTime()
    },
    onClickClockOut: function () {
      this.actionMessage = 'お疲れさまでした！'
      this.greetingIcon = 2
      this.clearTime()
    },
    clearTime: function () {
      // 既存のタイマーがあればキャンセル
      if (this.clearTimer) {
        clearTimeout(this.clearTimer)
      }

      // 新しいタイマーをセット
      this.clearTimer = setTimeout(() => {
        this.actionMessage = null
        this.greetingIcon = null
        this.clearTimer = null
      }, 5000)
    },

    selectCategory: function (value) {
      this.selectedKanaValue = value
    },
    selectPerson: function (value) {
      this.selectedPerson = value
    },
    setDayOfWeek: function (day) {
      const weekDayStrJP = ['日', '月', '火', '水', '木', '金', '土']
      var d = day.replaceAll('/', '')
      var v = dayjs(d, 'YYYYMMDD', true).format('YYYYMMDD')
      if (d === v) {
        var date = new Date(dayjs(d, 'YYYYMMDD', true).format('YYYY/MM/DD'))
        return '　' + weekDayStrJP[date.getDay()] + ''
      } else {
        return ''
      }
    }
  }
}
